export default [
  {
    'text': '결제대기',
    'state': 'WAITING'
  },
  {
    'text': '결제 성공',
    'state': 'SUCCESS'
  },
  {
    'text': '결제 실패',
    'state': 'FAIL'
  },
  {
    'text': '결제 취소',
    'state': 'CANCEL'
  },
];



// WEBPACK FOOTER //
// ./src/api/paymentState.js